import { handleErrors } from "../util/api-utils";

export function setSalesLeaderAgentProfile(agentProfile) {
    return fetch("api/InternalIdentity/SetSalesLeaderAgentProfile", {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(agentProfile),
    }).then(handleErrors);
}

export async function getSalesLeaderAgentProfile() {
    const response = await fetch("api/InternalIdentity/GetSalesLeaderAgentProfile", {
        method: "GET",
        headers: {
            Accept: "application/json",
        },
    });
    if (response.status === 204) {
        return null;
    }
    return handleErrors(response);
}
